import type { TransportTicketPickerStore } from "../../types/context/TransportTicketPickerContext";
import type { MuiCityOption } from "../../types/forms/MuiCityOption";
import type { SearchTransportTicketPickerFormFields } from "../../types/forms/SearchTransportTicketPickerFormFields";


export const gtmCtaSeachSubmit = (data: SearchTransportTicketPickerFormFields, state: TransportTicketPickerStore, matches: boolean, cityList: Array<MuiCityOption> | undefined) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'recherche_titres',
        language: state.language || null,
        'ville_depart': data.departureCity?.code || null,
        'zone_depart': cityList?.find(city => city.code === data.departureCity?.code)?.zone || null,
        'ville_arrivee': data.arrivalCity?.code || null,
        'zone_arrivee': cityList?.find(city => city.code === data.arrivalCity?.code)?.zone || null,
        'tarif_reduction': data.reducedPriceEligible || null,
        'transport_type': data.transportModeCode || null,
        'tarif_type': data.reducedPriceProfile || null,
        'breakpoint_type': matches ? 'desktop' : 'mobile'
    });
}

export const gtmCtaNewSearch = (state: TransportTicketPickerStore, url: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'interaction_selecteur',
    'cta_location': 'resultat selecteur', // valeur fixe
    'click_text': 'nouvelle recherche', // valeur fixe
    'click_url': url,
    'language': state.language, // 'fr', 'en'
    });
}

export const gtmCtaMoreTitle = (state: TransportTicketPickerStore, text: string, url: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'interaction_selecteur',
        'cta_location': 'resultat selecteur', // valeur fixe
        'click_text': text, // valeur issue de l'interface
        'click_url': url,
        'language': state.language, // 'fr', 'en'
    });
}